import type { ApplicationVersionDTO, ApplicationVersionVO, PageResult } from '@eliboo/api-models';

import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { getEnv } from '@env';

@Injectable()
export class ApplicationVersionService {
  env = getEnv();
  public http: HttpClient = inject(HttpClient);
  getVersion(releaseNotesEnum: ApplicationVersionVO['releaseNotesEnum']) {
    const url = `${this.env.baseUrl}eliboo-app-boot/app-api/v1/applicationVersion/listCondition`;
    return this.http.post<PageResult<ApplicationVersionDTO>>(url, {
      md5: '我的引立播',
      pageSize: 1,
      releaseNotesEnum,
      wrapperX: {
        orderby: ['modifyTime.desc'],
      },
    });
  }
}
